import React, {useState, useEffect} from 'react';
import {NavLink} from "react-router-dom";
import '../../assets/css/card-slider.css';
import arrowImg from '../../assets/images/icons/errow.png';
import Slider from 'react-slick';
import {requestPostHTTP} from "../helpers/helper";
import Loader from "./Loader";

const GameTaskSlider = (props) => {
    const [gameTasks, setGameTasks] = useState([]);
    const [notFoundTasks, setNotFoundTasks] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchGameTaskData() {
            try {
                const getDailyGameTasks = await requestPostHTTP('/v1/challenges/games');
                if (getDailyGameTasks.data.length > 0) {
                    setGameTasks(getDailyGameTasks.data);
                } else {
                    setNotFoundTasks(true);
                }
            } catch (error) {
                console.error('Error fetching game task data:', error);
                setNotFoundTasks(true);
            } finally {
                setLoading(false);
            }
        }

        fetchGameTaskData();

    }, []);

    const  windowWidth = window.innerWidth;
    let slidesToShow = 3.999;
    if (windowWidth > 850 && windowWidth <= 900) {
        slidesToShow = 2.999;
    } else if (windowWidth <= 850) {
        slidesToShow = 1;
    }
    const settings = {
        dots: false,
        infinite: gameTasks.length > 4,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 10000,
    };

    return (
        <section>
            <div className="mt-4 cards-wrapper card-slider-wrapper gaming-tasks-slider-wrapper">
                <div className="card-slider-heading">
                    <h2 className="headingz mb-4">Daily Gaming Tasks
                        <span className="errow-icon">
                            <img src={arrowImg} alt="errow-img"/>
                        </span>
                    </h2>
                    <p className="main-slider-heading">Choose your favorite game and play the daily gaming tasks</p>
                </div>

                {loading ? (
                    <Loader/>
                ) : (
                    <Slider {...settings} className="slider card-slider arrow-light slider-gap sliderz tournaments">
                        {gameTasks.length > 0 && gameTasks.map(cardSlider => (
                            <NavLink key={cardSlider.id} to={`/game-challenges/${cardSlider.gameId}`}>
                                <div  className="cards-round">
                                    <img className="card-img" src={cardSlider.thumbnail} alt="Card-img"/>
                                    <div className="cards-info">
                                        <h3 className="cards-label text-white">
                                            {cardSlider.game}
                                        </h3>
                                    </div>
                                </div>
                            </NavLink>
                        ))}
                    </Slider>
                )}

                {notFoundTasks && (
                    <div className="d-flex justify-content-center align-items-center no-data-found">
                        <p>No daily gaming tasks found</p>
                    </div>
                )}

            </div>
        </section>
    );
}

export default GameTaskSlider;
